module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "admin"
  }, [_c('link', {
    attrs: {
      "rel": "stylesheet",
      "href": "https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css",
      "integrity": "sha384-BVYiiSIFeK1dGmJRAkycuHAHRg32OmUcww7on3RYdg4Va+PmSTsz/K68vbdEjh4u",
      "crossorigin": "anonymous"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm._onClickDump($event)
      }
    }
  }, [_vm._v("DUMP")]), _vm._v(" "), _c('div', {
    ref: "editor"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57903db4"}!./src/components/admin/admin.component.html
// module id = 158
// module chunks = 1